import { useAppSelector } from '@/app/hooks';
import { selectCurrentWorkspace } from '@/modules/Dashboard/Workspaces/workspaceSlice';

/**
 * True when the tenant has a connected Stripe account with API access (MRR, subscriptions, etc.).
 * Workspace payloads from GET /workspaces include `stripeFinancialFeaturesEnabled`.
 */
export function useStripeFinancialFeaturesEnabled(): boolean {
  return useAppSelector(selectCurrentWorkspace)?.stripeFinancialFeaturesEnabled === true;
}
